import { Box, Text } from "ink";
import { isString } from "lodash";
import React, { FunctionComponent } from "react";

const logTypeColorProps = (type: LogType) => {
	switch (type) {
		case "info":
			return { color: "white", backgroundColor: "blue" };

		case "warn":
			return { color: "black", backgroundColor: "yellow" };

		case "error":
			return { color: "white", backgroundColor: "red" };

		default:
			return { color: "black", backgroundColor: "white" };
	}
};

export type LogType = "info" | "warn" | "error" | "dir" | "log";
export type LogValue = string | object; // eslint-disable-line @typescript-eslint/ban-types

interface LogProps {
	type: LogType;
	values: LogValue[];
}

const Log: FunctionComponent<LogProps> = ({ type, values }) => {
	return (
		<Box>
			<Box width={8}>
				<Text bold {...logTypeColorProps(type)}>
					{type}:
				</Text>
			</Box>
			<Box flexGrow={1}>
				<Text
					color={
						type === "error" ? "red" : type === "warn" ? "yellow" : undefined
					}
				>
					{values.map((v, i) => {
						if (isString(v)) {
							return <Text key={i}>{v}</Text>; // eslint-disable-line react/no-array-index-key
						}

						return <Text key={i}>{JSON.stringify(v, null, "2")}</Text>; // eslint-disable-line react/no-array-index-key
					})}
				</Text>
			</Box>
		</Box>
	);
};

export default Log;
